module.exports = __webpack_public_path__ + "media/images/countrysquared/sr-3aac6b8dc0163011ab3bd20f324ca0b1.svg";